import React from 'react';
import { NavLink } from 'react-router-dom';
import { Users, Briefcase, GraduationCap, FileText, List, Image } from 'lucide-react';
import '../App.css';
import logo from '../logo.png';

const Sidebar = () => {
    const navItems = [
        // { path: '/accounts', label: 'Quản lý tài khoản', icon: <Users size={20} /> },
        // { path: '/jobs', label: 'Quản lý công việc', icon: <Briefcase size={20} /> },
        { path: '/candidates', label: 'Danh sách tài khoản', icon: <Users size={20} /> },
        { path: '/training', label: 'Gương sáng vươn lên', icon: <GraduationCap size={20} /> },
        { path: '/news', label: 'Chính sách hỗ trợ', icon: <FileText size={20} /> },
        // { path: '/categories', label: 'Danh mục', icon: <List size={20} /> },
        { path: '/banner', label: 'Quản lý Banner', icon: <Image size={20} /> },
    ];

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <img src={logo} alt="Logo" className="logo" />
                <div className="brand-text">
                    <div className="brand-title" style={{ color: "black" }}>UBND Xã Yên Định</div>
                    {/* <div className="brand-subtitle">Tỉnh Bắc Ninh</div> */}
                </div>
            </div>
            <nav className="sidebar-nav">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </nav>
        </div>
    );
};

export default Sidebar;
